// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { UpdateAssociationBindingManager, UpdateAssociationBindingManagerSchema } from 'api/gen/UpdateAssociationBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateAssociationBindingManagerBaseObject, ValidateAssociationBindingManagerBaseObjectSchema } from 'api/gen/ValidateAssociationBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateUpdateAssociationBindingManager'),
  binding: t.union([UpdateAssociationBindingManagerSchema, t.null]),
});

export const ValidateUpdateAssociationBindingManagerSchema = excess(t.intersection([ValidateAssociationBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateUpdateAssociationBindingManager extends t.TypeOf<typeof ValidateUpdateAssociationBindingManagerSchema> {}
